import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxBadgeComponent, OnyxDistancePipe } from '@onyx/angular';
import { DictionaryCode } from '../../../../common/enums/dictionary-code';
import { FleetState } from '../../common/enums/fleet-state';
import { FleetTypeHelper } from '../../common/helpers/fleet-type.helper';
import type { Fleet, SimplifiedFleet } from '../../common/interfaces/fleet';

@Component({
  selector: 'app-fleet-modal-header-description',
  imports: [OnyxDistancePipe, TranslatePipe, OnyxBadgeComponent],
  templateUrl: './fleet-modal-header-description.component.html',
  styleUrl: './fleet-modal-header-description.component.scss',
})
export class FleetModalHeaderDescriptionComponent {
  public readonly vehicle = input.required<Fleet | SimplifiedFleet>();

  protected readonly DictionaryCode = DictionaryCode;
  protected readonly FleetState = FleetState;

  protected isVehicle = computed(() =>
    FleetTypeHelper.isVehicle(this.vehicle()),
  );
}
